import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { colors, headingStyle } from '../styles/shared.js';
import { t } from '../i18n.js';
import { cmdMenuSelect } from '../commands.js';

// Must match src/screens.rs MENU_KEYS order
const MENU_ITEMS = [
  { key: 'menu-new-game' },
  { key: 'menu-resume-game' },
];

@customElement('game-menu')
export class GameMenu extends LitElement {
  static styles = [
    colors,
    headingStyle,
    css`
      :host {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
      }
      .menu-box {
        background: rgba(0, 0, 0, 0.75);
        border-radius: 16px;
        padding: 2rem 3rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1.5rem;
        pointer-events: auto;
        text-align: center;
      }
      .menu-items {
        display: flex;
        flex-direction: column;
        gap: 0.8rem;
        align-items: center;
      }
      .menu-item {
        position: relative;
        font-size: 1.6rem;
        cursor: pointer;
        padding: 0.4rem 1.2rem;
        color: var(--color-cyan);
        user-select: none;
      }
      @media (pointer: fine) {
        .menu-item.selected::before {
          content: '\u25B8';
          position: absolute;
          right: 100%;
          margin-right: 0.3rem;
        }
      }
    `,
  ];

  @property({ type: Number }) accessor menuSelection = 0;
  @property({ type: Boolean }) accessor hasSave = false;

  private _onItemClick(visualIndex: number) {
    cmdMenuSelect(visualIndex);
  }

  render() {
    const visibleItems = MENU_ITEMS.filter(
      (item) => item.key !== 'menu-resume-game' || this.hasSave,
    );

    return html`
      <div class="menu-box">
        <div>
          <div class="heading">${t('title-name')}</div>
          <div class="subheading">${t('title-subtitle')}</div>
        </div>
        <div class="menu-items">
          ${visibleItems.map(
            (item, visualIdx) => html`
              <div
                class="menu-item ${visualIdx === this.menuSelection ? 'selected' : ''}"
                @click=${() => this._onItemClick(visualIdx)}
              >
                ${t(item.key)}
              </div>
            `,
          )}
        </div>
      </div>
    `;
  }
}
